import { Options } from 'react-lottie';
import { LoadDotsAnimation } from '~/assets';
import { Animation, getTheme, ifStyle, pxToRem, styled } from '~/modules';

const brandPrimaryMain = getTheme('brand.primary.main');
const brandPrimaryContrast = getTheme('brand.primary.contrast');
const brandSecondaryMain = getTheme('brand.secondary.main');
const brandSecondaryContrast = getTheme('brand.secondary.contrast');
const backgroundZ4 = getTheme('background.z4');
const backgroundReverseZ3 = getTheme('background.reverse.z3');

const themeRadiusButton = getTheme('themeRadius.button');
const borderWidthXxs = getTheme('borderWidth.xxs');

const isSecondary = ifStyle('$secondary');
const isTertiary = ifStyle('$tertiary');
const isTransparent = ifStyle('$transparent');
const isDisabled = ifStyle('$disabled');
const isLoading = ifStyle('$loading');
const isColumn = ifStyle('$column');
const isFullWidth = ifStyle('$fullWidth');

type ButtonProps = {
  $secondary?: boolean | string;
  $tertiary?: boolean | string;
  $transparent?: boolean;
  $disabled?: boolean;
  $loading?: boolean;
  $column?: boolean;
  $fullWidth?: boolean;
};

export const Button = styled.button<ButtonProps>`
  display: flex;
  background-color: ${isSecondary(
    brandSecondaryMain,
    isTertiary(
      backgroundReverseZ3,
      isTransparent('transparent', brandPrimaryMain),
    ),
  )};
  color: ${isSecondary(
    brandSecondaryContrast,
    isTertiary(
      backgroundZ4,
      isTransparent(brandPrimaryMain, brandPrimaryContrast),
    ),
  )};
  border-radius: ${themeRadiusButton}px;
  border: ${isTransparent(borderWidthXxs, 0)}px solid ${brandPrimaryMain};
  flex-direction: ${isColumn('column', 'row')};
  opacity: ${isDisabled(0.3, 1)};
  pointer-events: ${isDisabled('none', isLoading('none'))};

  height: ${pxToRem(44)};
  width: ${isFullWidth('100%', pxToRem(250))};
  justify-content: center;
  align-items: center;
  padding: 0;
  font-weight: 500;
  font-size: ${pxToRem(17)};

  &:active {
    opacity: ${isDisabled(0.3, 0.8)};
    cursor: ${isDisabled('not-allowed', isLoading('not-allowed', 'pointer'))};
  }
`;

type LoadingIndicatorProps = {
  options?: Options;
};

export const LoadingIndicator = styled(Animation).attrs({
  options: {
    animationData: LoadDotsAnimation,
  },
  width: pxToRem(70),
  height: pxToRem(70),
  speed: 1.5,
})<LoadingIndicatorProps>``;
